import axios from 'axios';
import {
  baseUrl,
} from '@/config';
import { forEach, isEmpty } from 'lodash';

export default {
  /**
   * [getWorkHistoryList 성능운영 > 네트워크 장비 > 노드 > 스트립트 수행이력 목록을 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getWorkHistoryList(params) {
    return axios.post(`${baseUrl}/config/get-work-history-list.do`, params);
  },
  /**
   * [getNetdeviceObjInfo 성능운영 > 네트워크 장비 > 노드 > 장비 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getNetdeviceObjInfo(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-obj-info.do`, params);
  },
  /**
   * [getNetinterfaceObjInfo 성능운영 > 인터페이스 > 노드 > 장비 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getNetinterfaceObjInfo(params) {
    return axios.post(`${baseUrl}/config/get-netinterface-obj-info.do`, params);
  },
  /**
   * [getStpInterfaceList 성능운영 > 네트워크 장비 > 노드 > 프로토콜 stp정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getStpInterfaceList(params) {
    return axios.post(`${baseUrl}/config/get-stp-interface-list.do`, params);
  },
  /**
   * [getStpInterfaceList 성능운영 > 네트워크 장비 > 노드 > 프로토콜 stp정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getNetworkVrrpList(params) {
    return axios.post(`${baseUrl}/config/get-network-vrrp-list.do`, params);
  },
  /**
   * [getNetworkHsrpList 성능운영 > 네트워크 장비 > 노드 > 프로토콜 hsrp정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getNetworkHsrpList(params) {
    return axios.post(`${baseUrl}/config/get-network-hsrp-list.do`, params);
  },
  /**
   * [getTcpConnectionInformationList 성능운영 > 네트워크 장비 > 노드 > 프로토콜 tcp정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getTcpConnectionInformationList(params) {
    return axios.get(`${baseUrl}/config/get-tcp-connection-info-list.do`, {
      params,
    });
  },
  /**
   * [getTcpRoutingInformationList 성능운영 > 네트워크 장비 > 노드 > 라우팅 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getTcpRoutingInformationList(params) {
    return axios.get(`${baseUrl}/config/get-tcp-routing-info-list.do`, {
      params,
    });
  },
  /**
   * 벤더별 라우팅 스크립트 템플릿을 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getRoutingTemplateListOfVendor(params) {
    return axios.post(`${baseUrl}/config/get-routing-template-list-of-vendor.do`, params);
  },
  /**
   * 장비의 라우팅 스냅샷 수집 타입을 조회한다.
   * CLI: CLI 방식으로 수집으로 SNMP 수집 권장 하지않지 않도록 함.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getRoutingSnapshotTypeOfObj(objId) {
    return axios.get(`${baseUrl}/config/get-routing-snapshot-type-of-obj.do`, {
      params: {
        objId,
      },
    });
  },
  /**
   * [exportTcpRoutingInfoList 성능운영 > 네트워크 장비 > 노드 > 라우팅 정보를 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportTcpRoutingInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-tcp-routing-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [exportTcpRoutingInfoList 성능운영 > 네트워크 장비 > 노드 > 라우팅 정보를 엑셀 출력한다. (CLI)]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportRoutingScriptResult(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-routing-script-result-by-excel.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [exportScriptInfo 구성정보 > 네트워크 장비 > 노드 > 스트립트 수행이력 목록을 엑셀 출력한다.] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author yelim -> NaJY
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportScriptInfo(params) {
    return axios.post(`${baseUrl}/config/export-script-info-list.do`, params);
  },
  /**
   * [getCiscoCDPInformationList 구성정보 > 네트워크 장비 > 노드 > Cisco 장비의 CDP 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getCiscoCDPInformationList(params) {
    return axios.post(`${baseUrl}/config/get-cisco-cdp-info-list.do`, params);
  },
  /**
   * [getCiscoFlashInformationList 구성정보 > 네트워크 장비 > 노드 > Cisco 장비의 flash 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getCiscoFlashInformationList(params) {
    return axios.post(`${baseUrl}/config/get-cisco-flash-info-list.do`, params);
  },
  /**
   * [getCiscoMemoryInformationList 구성정보 > 네트워크 장비 > 노드 > Cisco 장비의 메모리 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getCiscoMemoryInformationList(params) {
    return axios.post(`${baseUrl}/config/get-cisco-memory-info-list.do`, params);
  },
  /**
   * [getCiscoChassisInformationList 구성정보 > 네트워크 장비 > 노드 > Cisco 장비의 chassis 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getCiscoChassisInformationList(params) {
    return axios.post(`${baseUrl}/config/get-cisco-chassis-info-list.do`, params);
  },
  /**
   * [getCiscoCardsInformationList 구성정보 > 네트워크 장비 > 노드 > Cisco 장비의 모듈 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getCiscoCardsInformationList(params) {
    return axios.post(`${baseUrl}/config/get-cisco-cards-info-list.do`, params);
  },
  /**
   * [exportCiscoInfoList 구성정보 > 네트워크 장비 > 노드 > Cisco 장비 정보 목록을 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportCiscoInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-cisco-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [getInterfaceArp 구성정보 > 네트워크 장비 > 노드 > 연결장비 목록을 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getInterfaceArp(params) {
    return axios.post(`${baseUrl}/config/get-interface-arp.do`, params);
  },
  /**
   * [exportDeviceArpInfoList 구성정보 > 네트워크 장비 > 노드 > 연결장비 목록을 엑셀출력]
   * @author yelim
   * @param  {[type]} managegroupId [managegroupId]
   * @return {[type]}               [description]
   */
  exportDeviceArpInfoList(netdeviceId) {
    window.location.assign(`${baseUrl}/config/export-device-arp-info-list.do?netdeviceId=${netdeviceId}`);
  },
  /**
   * [exportInterfaceArpInfoList 구성정보 > 인터페이스 > 노드 > 연결장비 목록을 엑셀출력]
   * @author yelim
   * @param  {[type]} managegroupId [managegroupId]
   * @return {[type]}               [description]
   */
  exportInterfaceArpInfoList(objId) {
    window.location.assign(`${baseUrl}/config/export-interface-arp-info-list.do?objId=${objId}`);
  },
  /**
   * [getNetdevice 구성정보 > 네트워크 장비 > 노드 > netdevice 정보를 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getNetdevice(params) {
    return axios.post(`${baseUrl}/config/get-netdevice.do`, params);
  },
  /**
   * [getManagetype 구성정보 > 네트워크 장비 > 노드 > managetype 정보를 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getManagetype(params) {
    return axios.post(`${baseUrl}/config/get-managetype.do`, params);
  },
  /**
   * [setArpScan 구성정보 > 네트워크 장비 > 노드 > 연결장비 인터페이스 연결 정보 모델링을 수행한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  setArpScan(params) {
    return axios.post(`${baseUrl}/config/set-arp-scan.do`, params);
  },
  /**
   * [getNetinterfaceList 구성정보 > 네트워크 장비 > 노드 > 인터페이스 정보를 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getNetinterfaceList(params) {
    return axios.post(`${baseUrl}/config/get-netinterface-list.do`, params);
  },
  /**
   * [exportInterfaceInfoList 구성정보 > 네트워크 장비 > 노드 > 인터페이스 목록을 엑셀 출력한다.] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author yelim -> NaJY
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportNetinterfaceInfoList(params) {
    return axios.post(`${baseUrl}/config/export-netinterface-list.do`, params);
  },
  /**
   * [exportProtocolInfoList 구성정보 > 네트워크 장비 > 노드 > 프로토콜 목록을 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportProtocolInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-protocol-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [getNetdeviceConfigInfoDeviceList 구성정보 > 그룹 > 장비 목록 데이터 호출]
   * @author {Yang}
   * @param  {[ConfigParamVO]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-config-info-device-list.do`, params);
  },
  /**
   * [exportNetdeviceConfigInfoDeviceList 구성정보 > 그룹 > 장비 목록 엑셀출력]
   * @author {Yang}
   * @param  {[Integer]} params [managegroupId]
   * @return {[type]}        [description]
   */
  exportNetdeviceConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/export-netdevice-config-info-device-list.do`, params);
  },
  /**
   * [getNetdeviceConfigInfoList 구성정보 > 그룹 > 컨피그 정보 데이터 호출]
   * @author {Yang}
   * @param  {[ConfigParamVO]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceConfigInfoList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-config-info-config-list.do`, params);
  },
  /**
   * [exportNetdeviceConfigInfoDeviceList 구성정보 > 그룹 > 컨피그 정보 엑셀출력] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author {Yang -> NaJY}
   * @param  {[Integer]} params [managegroupId]
   * @return {[type]}        [description]
   */
  exportNetdeviceConfigInfoList(params) {
    return axios.post(`${baseUrl}/config/export-netdevice-config-info-config-list.do`, params);
  },
  /**
   * [getNetdeviceConfigInfoDeviceAccountList 구성정보 > 그룹 > 장비계정]
   * @author {Yang}
   * @param  {[ConfigParamVO]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceConfigInfoDeviceAccountList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-config-info-device-account-list.do`, params);
  },
  /**
   * [exportNetdeviceConfigInfoDeviceAccountList 구성정보 > 그룹 > 장비계정 엑셀출력] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author {Yang -> NaJY}
   * @param  {[Integer]} managegroupId [managegroupId]
   * @return {[type]}               [description]
   */
  exportNetdeviceConfigInfoDeviceAccountList(params) {
    return axios.post(`${baseUrl}/config/export-netdevice-config-info-device-account-list.do`, params);
  },
  /**
   * [구성정보/네트워크장비] 장비 점검이 이루어진 날짜 목록
   * @author kimjy
   * @param  {Object} params managegroupId, selectCheckMonth
   */
  getNetdeviceRegularCheckDayList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-regular-check-day-list.do`, params);
  },
  /**
   * [구성정보/네트워크장비] 장비 점검 리스트
   * @author kimjy
   * @param  {Object} params managegroupId, selectCheckMonth
   */
  getNetdeviceRegularCheckList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-regular-check-list.do`, params);
  },
  /**
   * [구성정보/네트워크장비] 장비 점검 수행
   * @author kimjy
   * @param  {Object} params objIds
   */
  excuteNetdeviceCheck(params) {
    return axios.post(`${baseUrl}/config/excute-netdevice-check.do`, params);
  },
  /**
   * [구성정보/네트워크장비] 장비 점검 > 미변경 팝업
   * @author kimjy
   * @param  {Object} params objIds
   */
  getNetdeviceCheckInfo(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-${params.requestKey}-check-info.do`, params);
  },
  /**
   * [구성정보/네트워크장비] 장비 점검 > 변경 팝업
   * @author kimjy
   * @param  {Object} params objIds
   */
  getNetdeviceCheckHist(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-${params.requestKey}-check-hist.do`, params);
  },
  /**
   * [구성정보/네트워크장비] 장비 점검 > 비교 팝업
   * @author kimjy
   * @param  {Object} params objIds
   */
  getNetdeviceComparedData(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-${params.requestKey}-compared-data.do`, params);
  },
  /**
   * [getNetdeviceConfigInfoDevicePolicyViolationList 구성정보 > 그룹 > 정책위배현황 > 장비기준]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceDeviceViolationList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-device-violation.do`, params);
  },
  /**
   * [getNetdevicePolicyDetailInfo 구성정보 > 그룹 > 정책위배현황 > 장비기준 > 정책 상세팝업]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getNetdevicePolicyDetailInfo(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-policy-detail-info.do`, params);
  },
  /**
   * [getNetdeviceConfigInfochangePassword 구성정보 > 그룹 > 장비계정 팝업 - 패스워드 변경을 수행한다.]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceConfigInfochangePassword(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-config-info-change-password-list.do`, params);
  },
  /**
   * [getNetdeviceConfigInfoHistoryAccountList  구성정보 > 그룹 > 장비계정 팝업 - 변경 이력 정보를 가져온다.]
   * @author {Yang}
   * @param  {[Map<String, Object>]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceConfigInfoHistoryAccountList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-config-info-History-account-list.do`, params);
  },
  /**
   * [getNetdevicePolicyDetailInfo 구성정보 > 그룹 > 정책위배현황 > 장비기준 > 정책 감사수행]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceExecutePolicy(params) {
    return axios.post(`${baseUrl}/config/execute-policy.do`, params);
  },
  /**
   * [getNetdevicePolicyDetailInfo 구성정보 > 그룹 > 정책위배현황 > 장비기준 > 정책 수행결과 팝업]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getNetdevicePolicyExecuteResultList(params) {
    return axios.post(`${baseUrl}/config/get-policy-execute-result-list.do`, params);
  },
  /**
   * [getNetdeviceConfigInfoDownloadFileName 컨피그 정보 파일 저장]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceConfigInfoDownloadFileName(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-config-info-down-filename.do`, params);
  },
  /**
   * [getNetdeviceConfigInfoFileDownload 컨피그 정보 파일 불러오기]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceConfigInfoFileDownload(params) {
    window.location.assign(`${baseUrl}/config/export-netdevice-config-info-file-download.do?filePath=backupConfig&fileName=${params}`);
  },
  /**
   * [getNetdevicePolicyViolationList 구성정보 > 그룹 > 정책위배현황 > 정책기준]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getNetdevicePolicyViolationList(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-policy-violation.do`, params);
  },
  /**
   * [getNetdeviceConfigInfoBackup 구성정보 > Netdevice > 그룹 > 컨피그 정보 > 백업]
   * @author {Yang}
   * @param  {[List<Integer>]} objIds [objId 리스트]
   * @return {[type]}        [description]
   */
  executeNetdeviceConfigInfoBackup(objIds) {
    return axios.post(`${baseUrl}/config/execute-netdevice-config-info-backup.do`, objIds);
  },
  /**
   * [getNetdeviceConfigInfoSync 구성정보 > Netdevice > 그룹 > 컨피그 정보 > 동기화]
   * @author {Yang}
   * @param  {[List<Integer>]} objIds [objId 리스트]
   * @return {[type]}        [description]
   */
  executeNetdeviceConfigInfoSync(objIds) {
    return axios.post(`${baseUrl}/config/execute-netdevice-config-info-sync.do`, objIds);
  },
  /**
   * [getCurrentPolicyComplianceByDevice 구성정보 > 그룹 > 정책위배현황 > 정책의 장비별 준수/미준수 현황 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getCurrentPolicyComplianceByDevice(params) {
    return axios.post(`${baseUrl}/config/get-current-policy-compliance-by-device.do`, params);
  },
  /**
   * [getCurrentPolicyComplianceByRule 구성정보 > 그룹 > 정책위배현황 > 정책의 룰별 준수/미준수 현황 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getCurrentPolicyComplianceByRule(params) {
    return axios.post(`${baseUrl}/config/get-current-policy-compliance-by-rule.do`, params);
  },
  /**
   * [getCurrentRuleComplianceByDevice 구성정보 > 그룹 > 정책위배현황 > 정책의 룰별 장비 준수/미준수 현황 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getCurrentRuleComplianceByDevice(params) {
    return axios.post(`${baseUrl}/config/get-current-rule-compliance-by-device.do`, params);
  },
  exportNetdeviceRegularCheckList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-netdevice-regular-check-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      if (key === 'startDatetime' || key === 'checkDatetime' || !isEmpty(params[key])) {
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
      }
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [getRuleScriptDetailInfo 구성정보 > 그룹 > 정책위배현황 > 스크립트 수행 > 룰의 상세 정보 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getRuleScriptDetailInfo(params) {
    return axios.post(`${baseUrl}/config/get-rule-script-detail-info.do`, params);
  },
  /**
   * [구성정보/네트워크장비] 장비 점검 상세 팝업
   * @author kimjy
   * @param  {Object} params histSeq
   */
  getNetdeviceRegularCheckDetailInfo(params) {
    return axios.post(`${baseUrl}/config/get-netdevice-regular-check-detail-info.do`, params);
  },
  /**
   * [getNonComplianceDeviceList 구성정보 > 그룹 > 정책위배현황 > 스크립트 수행 > 미준수 장비 리스트 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getNonComplianceDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-non-compliance-device-list.do`, params);
  },
  /**
   * [executeScript 구성정보 > 그룹 > 정책위배현황 > 스크립트 수행 > 스크립트 실행]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  executeScript(params) {
    return axios.post(`${baseUrl}/config/execute-script.do`, params);
  },
  /**
   * 스크립트 수행 완료 여부를 확인한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkScriptCompletion(params) {
    return axios.post(`${baseUrl}/config/check-script-completion.do`, params);
  },
  /**
   * [getExecuteScriptResult 구성정보 > 그룹 > 정책위배현황 > 스크립트 수행 > 스크립트 실행 결과 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getExecuteScriptResult(params) {
    return axios.get(`${baseUrl}/config/get-execute-script-result.do`, {
      params,
    });
  },
  /**
   * [getExecuteProgressRate 구성정보 > 그룹 > 정책위배현황 > 수행 진행률 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getExecuteProgressRate(params) {
    return axios.post(`${baseUrl}/config/get-execute-progress-rate.do`, params);
  },
  /**
   * 노드>구성현황 기본정보
   * @author hyo
   * @param
   * @return
   */
  getNdConfigInfoBasic(params) {
    return axios.post(`${baseUrl}/config/get-nd-config-info-basicstatus.do`, params);
  },
  /**
   * 노드>구성현황 HW 정보
   * @author hyo
   * @param
   * @return
   */
  getNdConfigInfoHwinfo(params) {
    return axios.post(`${baseUrl}/config/get-nd-config-info-hwinfo.do`, params);
  },
  /**
   * 노드>구성현황 펌웨어리스트
   * @author hyo
   * @param
   * @return
   */
  getFirmwareFullList(params) {
    return axios.post(`${baseUrl}/config/get-firmware-full-list.do`, params);
  },
  /**
   * 노드 > 구성현황 수정
   * @author hyo
   * @param
   * @return
   */
  updateNdConfigInfo(params) {
    return axios.post(`${baseUrl}/config/update-nd-obj-config.do`, params);
  },
  /**
   * 네트워크 장비 목록 > 컬럼 설정 팝업 > 사용자가 선택한 확장 컬럼 및 구성 OID 템플릿을 조회한다.
   * @author Song
   * @param
   * @return
   */
  getConfigTemplateList() {
    return axios.get(`${baseUrl}/config/get-config-template-list.do`);
  },
  /**
   * 네트워크 장비 목록 > 컬럼 설정 팝업 > 설정한 컬럼 정보를 저장 및 수정 한다.
   * @author Song
   * @param
   * @return
   */
  setConfigTemplateColumn(params) {
    return axios.post(`${baseUrl}/config/set-config-template-column.do`, params);
  },
  /**
   * 네트워크 장비 목록 > 컬럼 설정 팝업 > 선택한 동적 컬럼 정보를 조회한다 ( 테이블에 표시 )
   * @author Song
   * @param
   * @return
   */
  getConfigTemplateColumns() {
    return axios.get(`${baseUrl}/config/get-config-template-columns.do`);
  },
  /**
   * 네트워크 장비 목록 > 구성  > 구성현황 > 선택한 구성 설정 정보 조회
   * @author Song
   * @param
   * @return
   */
  getTargetConfigTemplateAttrInfo(params) {
    return axios.post(`${baseUrl}/config/get-target-config-template-attr-info.do`, params);
  },
  /**
   * 네트워크 장비 목록 > 구성  > 구성현황 > SKT 커스텀 - TiAMS 연동 정보 조회
   * @author Song
   * @param
   * @return
   */
  getNdConfigInfoSktTiams(params) {
    return axios.post(`${baseUrl}/config/get-nd-config-info-skt-tiams.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/netdevice/netdevice-info.js